import React from 'react';
import Illustration, { IllustrationProps } from './Illustration';

//
const NoArchiveSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            viewBox="60 60 940 940"
        >
            <rect
                x="260.715"
                y="363.352"
                width="577.482"
                height="418.729"
                fill="#CED4DA"
            />
            <path
                d="M838.194 363.352V782.081"
                stroke="#000216"
                strokeWidth="3"
            />
            <rect
                x="324.734"
                y="218"
                width="449.625"
                height="449.625"
                fill="currentColor"
            />
            <path
                d="M354.478 506.849L349.343 489.59C341.224 462.302 316.137 443.593 287.667 443.593H160L260.716 782.085H838.198L756.304 506.849H354.478Z"
                fill="#E9ECEF"
            />
            <path
                d="M260.715 782.078H838.197"
                stroke="#000216"
                strokeWidth="3"
            />
            <path
                d="M838.196 782.082L756.303 506.845H354.477"
                stroke="#000216"
                strokeWidth="3"
            />
            <path
                d="M609.422 285.834L627.064 303.476L489.767 440.773L472.125 423.131L609.422 285.834Z"
                fill="white"
            />
            <path
                d="M489.656 285.834L472.014 303.476L609.311 440.773L626.953 423.131L489.656 285.834Z"
                fill="white"
            />
        </svg>
    );
};
const NoArchive: React.FC<IllustrationProps> = (props) => (
    <Illustration component={NoArchiveSvg} {...props} />
);
export default NoArchive;
